const SAVE_SETTINGS = 'SAVE_SETTINGS';
const SAVE_SETTINGS_PENDING = 'SAVE_SETTINS_PENDING';
const SAVE_SETTINGS_SUCCESS = 'SAVE_SETTINGS_SUCCES';

const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export default {
    SAVE_SETTINGS,
    SAVE_SETTINGS_PENDING,
    SAVE_SETTINGS_SUCCESS,
    UPDATE_SETTINGS,
};


// WEBPACK FOOTER //
// ./src/redux/modules/settings/constants.ts